import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';

import {ModalConfirmationComponent} from 'shared/modals/modal-confirmation/modal-confirmation.component';
import {Content} from 'shared/models/contents/content';
import {ContentType} from 'shared/models/contents/content-type';
import {SearchBarComponent} from 'shared/search-bar/search-bar.component';
import {ContentsOverviewService} from './services/contents-overview.service';
import {ContentsDetailsService} from '../contents-details/services/contents-details.service';
import * as Showdown from 'showdown';

@Component({
  selector: 'contents-overview',
  templateUrl: './contents-overview.component.html',
  styleUrls: ['./contents-overview.component.css'],
})
export class ContentsOverviewComponent implements OnInit {

  public activeStatus: 'all' | 'active' | 'inactive' = 'all';
  private contents: Array<Content> = [];
  public filteredContents: Array<Content> = [];
  public fieldsToSearch: Array<Array<string>> = [];
  public currentPage: Event;
  public converter: Showdown.Converter = new Showdown.Converter();
  private maxHeightControl: Array<boolean> = [];

  @ViewChild('deleteModal') private deleteModal: ModalConfirmationComponent;

  constructor(private contentsOverviewService: ContentsOverviewService,
    private contentsDetailsService: ContentsDetailsService,
    private router: Router) {

    this.contents = [];
  }

  public ngOnInit(): void {
    this.contentsOverviewService.getContents()
      .subscribe((contents: Array<Content>) => {
        this.contents = contents;
        this.filteredContents = contents;
        this.prepareFieldsToSearch();
        this.maxHeightControl.length = this.contents.length;
      });
  }

  public editContent(id: string): void {
    this.router.navigate(['contents', 'details', {contentId: id}]);
  }

  public createContent(): void {
    //this.router.navigateByUrl('contents/details');
    this.router.navigate(['contents', 'details', {orderno: this.contents.length+1}]);
  }

  public deleteContent(id: string): void {
    this.contentsOverviewService.deleteContent(id)
      .subscribe(() => {
        const index: number = this.contents.findIndex((content: Content) => {
          return content._id === id;
        });

        if (index > -1) {
          this.contents.splice(index, 1);
        }
      });
  }

  public showDeleteModal(id: string): void {
    const contentName: string = this.getContentById(id).title.de;
    const content: string = `Sind Sie sicher, dass Sie das Themenpaket "${contentName}" löschen möchten?`;

    this.deleteModal.setContent(content)
      .setEventData(id)
      .show();
  }

  public get filteredContentsByActiveStatus(): Array<Content> {
    return this.contents.filter((content) => {
      return this.filterByActiveStatus(content);
    });
  }

  public filterContents(eventContents: Array<Content>): void {
    this.filteredContents = eventContents;
  }

  public prepareFieldsToSearch(): void {
    this.fieldsToSearch = [];
    this.filteredContentsByActiveStatus.forEach((content) => {
      this.fieldsToSearch.push([
        content.description.de.toLowerCase(),
        content.title.de.toLowerCase(),
      ]);
    });
  }

  private filterByActiveStatus(content: Content): boolean {
    if (this.activeStatus === 'all') {
      return true;
    }

    const active: boolean = this.activeStatus === 'active';
    return content.active === active;
  }

  private getContentById(id: string): Content {
    return this.contents.find((content: Content) => {
      return content._id === id;
    });
  }

  public getTargetGroups(content:Content): string {
    if (content.omnibus) {
      return 'Für alle';
    }
    const sFree = content.targetGroups ? content.targetGroups.map(group => group.title).join(', ') : '';
    const sPurchase = content.targetGroupsPurchasable ? content.targetGroupsPurchasable.map(group => '<i class="fa fa-fw fa-shopping-cart"></i> ' + group.title).join(', ') : '';
    return sFree + (sFree != '' && sPurchase != '' ? '<br>' : '') + sPurchase;
  }

  public getActiveIcon(content: Content): string { // tslint:disable-line
    return content.active ? 'glyphicon-ok' : 'glyphicon-remove';
  }

  public getActiveClass(content: Content): string { // tslint:disable-line
    return content.active ? 'no-button-success' : 'no-button-danger';
  }

  public isFirstContent(content: Content): boolean {
    return content.orderno == 1;
  }

  public isLastContent(content: Content): boolean {
    return content.orderno == this.contents.length;
  }

  public getMaxHeight(id: number): string {
    if (this.maxHeightControl[id]) {
      return '300px';
    } else {
      return '85px';
    }
  }

  public toggleMaxHeight(id: number): void {
    if (!this.maxHeightControl[id]) {
      this.maxHeightControl[id] = true;
      return;
    }
    this.maxHeightControl[id] = false;
  }

  public changeSort(content1: Content, dir: number) {
    const content2 = this.contents.find((content: Content) => { return content.orderno == content1.orderno+dir; });
    content1.orderno += dir;
    content2.orderno -= dir;
    this.contentsDetailsService.updateContent(content1)
      .subscribe((content: Content) => {
        this.contentsDetailsService.updateContent(content2)
         .subscribe((content: Content) => {
           this.contents = this.contents.sort((b1, b2) => {
             return b1.orderno < b2.orderno ? -1 : 1;
           });
           this.contents = [...this.contents];
         });
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/contents/contents-overview/contents-overview.component.ts